import angular from 'angular';

TaskCommentsCtrl.$inject = [];
export default function TaskCommentsCtrl() {
    const vm = this;

    let random = "";
    for (let i = 0; i < 6; i++) random += "" + Math.floor(Math.random() * 101);

    const id = "cont-com-tar" + random;
    vm.id = id;

    setTimeout(() => {
        const url = `${Sigo.var.path}/app-vue?random=${random}#/comentarios-contenedor?id=${vm.taskId}&modelo=tareas&mostrarMenu=false`;
        const doc = document.getElementById(id);
        const iframe = document.createElement("iframe");
        iframe.width = "100%";
        iframe.height = "600px"
        iframe.style.border = 'none';
        iframe.src = url;
        doc.appendChild(iframe);
    }, 100);

}